import { render, staticRenderFns } from "./ImageAnnouncementCard.vue?vue&type=template&id=cada13b2&scoped=true&"
import script from "./ImageAnnouncementCard.vue?vue&type=script&lang=js&"
export * from "./ImageAnnouncementCard.vue?vue&type=script&lang=js&"
import style0 from "./ImageAnnouncementCard.vue?vue&type=style&index=0&id=cada13b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cada13b2",
  null
  
)

export default component.exports